import axios, { AxiosResponse } from 'axios';
import { CreateVirtualFishGroupInput } from '../../types/create-virtual-fish-group-input.type';

// POST
// Create virtual fish goup.
// /ewosapi/v1/planandprognosis/site/{localSiteId}/fishgroup
export const postVirtualFishGroup = async (
  localSiteId: string,
  request: CreateVirtualFishGroupInput
): Promise<AxiosResponse> => {
  return await axios.post<AxiosResponse>(`/ewosapi/v1/planandprognosis/site/${localSiteId}/fishgroup`, request);
};
